import type { Notification, Paginated, PaginationInput } from '@moussenaires/shared';

import { api } from './client.js';

export const notificationsApi = {
  list: (query: Partial<PaginationInput> = {}) =>
    api.get<Paginated<Notification>>(
      `/notifications${query.page ? `?page=${query.page}&pageSize=${query.pageSize ?? 20}` : ''}`,
    ),
  unreadCount: () => api.get<{ count: number }>('/notifications/unread-count'),
  markRead: (id: number) => api.patch<void>(`/notifications/${id}/read`),
  markAllRead: () => api.post<void>('/notifications/read-all'),
};
